module.exports = __webpack_public_path__ + "media/images/member/484x512-aa02423bd70b7b20a3ced7a4daf44c7d.png";